import {memo} from 'react';
import styled from 'styled-components';
import {Palette, getRandomPrimaryColor} from 'hubbl-shared';
import {FontConfig} from '../../constants/FontConfig';

interface EventTagProps {
  tag: string;
  onRemove?: () => void;
  className?: string;
}

const TagContainer = styled.span<{$color: string}>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  margin: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  font-family: ${FontConfig.Heading7.fontFamily};
  font-size: ${FontConfig.Heading7.fontSize}px;
  font-weight: ${FontConfig.Heading7.fontWeight};
  letter-spacing: ${FontConfig.Heading7.letterSpacing}px;
  white-space: nowrap;
  background: ${props => props.$color};
  color: ${Palette.almostBlack};
  border: 1px solid ${props => props.$color};
  transition: all 0.2s ease;

  &:hover {
  }
`;

const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  width: 16px;
  height: 16px;
  color: inherit;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.2);
  }
`;

export const EventTag = memo(({tag, onRemove, className}: EventTagProps) => {
  const tagColor = getRandomPrimaryColor(tag) || Palette.primaryCherokee;

  return (
    <TagContainer $color={tagColor} className={className}>
      {tag}
      {onRemove && (
        <RemoveButton onClick={onRemove} aria-label="Remove tag">
          ✕
        </RemoveButton>
      )}
    </TagContainer>
  );
});
